<template>
  <div class="banner">
    <div class="banner-wrapper">
      <div class="banner-img">
        <img src="../../../assets/images/banner/banner-qy.jpg" alt="" />
      </div>
    </div>
    <div class="breadcrumb-com">
      <img src="../../../assets/images/BTOC/dh.png" alt="" />
      <div @click="goUrl">企业展示</div>
      <i class="el-icon-d-arrow-right"></i>
      <div>{{ queryInfo.companyName }}</div>
    </div>
    <div class="container">
      <div class="infoTitle">{{ queryInfo.companyName }}</div>
    </div>
    <div class="qyBox" v-if="queryInfo.id">
      <div class="qyInfo">
        <div>
          <!-- <h3>公司名称：</h3>
          <p>
            {{ queryInfo.companyName }}
          </p> -->
          <h3 class="margin-top10">公司简介：</h3>
          <p>
            {{ queryInfo.description }}
          </p>
          <div>
            <h3 class="margin-top10">公司网站：</h3>
            <a :href="queryInfo.website" target="_blank">
              {{ queryInfo.website }}
            </a>
          </div>
        </div>
      </div>
      <div class="qyImgBox">
        <img
          class="busImg"
          v-if="queryInfo.business"
          :src="queryInfo.business"
          :alt="queryInfo.companyName"
        />
        <div class="reserve" v-else></div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  components: {},
  directives: {},
  data() {
    return {
      selectedCompany: {},
      companies: [],
      queryInfo: {},
    };
  },
  created() {
    this.queryInfo = this.$route.params.rowData;
    console.log(this.queryInfo);
  },
  mounted() {},
  methods: {
    goUrl() {
      this.$router.push({
        name: "EnterpriseView",
      });
    },
  },
};
</script>

<style scoped>
.banner-img {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 180px;
  margin-bottom: 22px;
}
.banner-img img {
  width: 100%;
  height: 600px;
  backdrop-filter: color(100% 100%);
}
.breadcrumb-com {
  width: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
}
.breadcrumb-com img {
  margin-right: 6px;
  width: 20px;
  height: 20px;
}
.breadcrumb-com div {
  height: 24px;
  font-size: 22px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #54595d;
  line-height: 24px;
  cursor: pointer;
}
i {
  margin-top: 4px;
  margin-left: 6px;
  margin-right: 6px;
}
.breadcrumb-com .clickUrl {
  height: 24px;
  font-size: 22px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #3682ed;
  line-height: 24px;
}
.container {
  width: 100%;
}
.infoTitle {
  text-align: center;
  font-size: 30px;
  font-weight: bold;
  margin: 30px 0;
}
.qyBox {
  width: 100%;
}
.reserve {
  width: 100%;
  height: 600px;
}
.qyTitle {
  position: absolute;
  bottom: 60px;
  left: 40px;
  /* color: #fff; */
  font-size: 24px;
  font-weight: bold;
}
.qyInfo {
  border: 1px solid #ccc;
  /* border-radius: 15px; */
  padding: 20px;
}
.qyBox img {
  /* width: 100%; */
  height: 600px;
  object-fit: contain;
}
.logoBox {
  width: 100%;
  margin-top: 20px;
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-start;
}
.logoItem {
  width: 80px;
  height: 80px;
  overflow: hidden;
  margin-right: 20px;
  border-radius: 16px;
  border: 1px solid #ccc;
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap; /* 防止内容换行 */
}
.logoItem:last-child {
  margin-right: 0;
}
.logoItem img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.margin-top10 {
  margin-top: 10px;
}
.qyImgBox {
  display: flex;
  justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/components/children/Enterprise/EnterpriseInfo.vue